import { CrossSVG } from '@sbercloud/uikit-product-icons';
import { ButtonTonal } from '@snack-uikit/button';
import { FieldText, FieldTextArea } from '@snack-uikit/fields';
import { Checkbox } from '@snack-uikit/toggles';
import { Typography } from '@snack-uikit/typography';
import { Controller, useForm, useWatch } from 'react-hook-form';

import { Condition } from '@/components/static';
import { FEEDBACK_FORM_CONFIG } from '@/constant/forms';
import { VALIDATION_ERRORS } from '@/constant/validation';
import { useFeedbackPropsCtx } from '@/hooks/ctx';
import { FeedbackFormValues } from '@/types/feedback';
import { equals, isPresentString } from '@/utils/common';
import { emailRegExp } from '@/utils/regExp';

import s from './styles.module.scss';

export type FeedbackFormProps = {
  onClosePopover(): void;
};

export function FeedbackForm({ onClosePopover }: FeedbackFormProps) {
  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<FeedbackFormValues>({
    defaultValues: {
      comment: '',
      wantEnterEmail: false,
      email: '',
    },
  });
  const { isLoadingSendFeedback, onSubmitForm } = useFeedbackPropsCtx();

  const { wantEnterEmail, comment } = useWatch({ control });

  return (
    <form
      onSubmit={handleSubmit(({ comment, email }) => {
        onSubmitForm({ isLiked: false, email, comment });
      })}
      className={s.feedback_form_container}
    >
      <div className={s.feedback_form_header_container}>
        <Typography.SansTitleL>
          Спасибо за отзыв!
          <br />
          Оставьте комментарий
        </Typography.SansTitleL>
        <CrossSVG className={s.close_icon} onClick={() => onClosePopover()} />
      </div>
      <Controller
        control={control}
        name='comment'
        rules={{ required: VALIDATION_ERRORS.notEmpty }}
        render={({ field }) => (
          <FieldTextArea
            allowMoreThanMaxLength={false}
            maxRows={FEEDBACK_FORM_CONFIG.comment.maxRows}
            maxLength={FEEDBACK_FORM_CONFIG.comment.maxLength}
            size='l'
            placeholder='Комментарий'
            {...field}
            error={errors.comment?.message}
          />
        )}
      />
      <div className={s.email_checkbox_wrapper}>
        <Controller
          control={control}
          name='wantEnterEmail'
          render={({ field }) => (
            <Checkbox onBlur={field.onBlur} onChange={checked => field.onChange(checked)} checked={field.value} />
          )}
        />
        <Typography.LightTitleM> Свяжитесь со мной </Typography.LightTitleM>
      </div>
      <Condition when={Boolean(wantEnterEmail)}>
        <Controller
          control={control}
          name='email'
          rules={{ required: VALIDATION_ERRORS.notEmpty, pattern: emailRegExp }}
          render={({ field }) => (
            <FieldText
              size='l'
              hint='Оставьте email, чтобы узнать об изменении или получить ответ на вопрос'
              placeholder='Электронная почта'
              error={equals(errors.email?.type, 'pattern') ? VALIDATION_ERRORS.email : errors.email?.message}
              {...field}
            />
          )}
        />
      </Condition>

      <ButtonTonal
        disabled={!isPresentString(comment)}
        loading={isLoadingSendFeedback}
        fullWidth
        label='Оставить комментарий'
        size='l'
        type='submit'
      />
    </form>
  );
}
